import React from "react";
import Ingredients from "./ingredients";
import { Switch, Redirect } from "react-router-dom";
import PermissionRoute from "../../components/hoc/PermissionRoute";
import IngredientDetail from "./ingredientDetail";
import SupplierSearchIngredients from "./supplierSearchIngredients";
import { connect } from "react-redux";
import { IApplicationState } from "../../redux/reducers";

import { routes } from "../routes";

const IngredientRouter: React.FC = (props: any) => {
	const subscription_type = props.profile?.company?.subscription_type;
	const isSupplier = subscription_type === "supplier";

	return (
		<Switch>
			<PermissionRoute
				exact
				path={routes.INGREDIENTS_SEARCH}
				component={isSupplier ? () => <Redirect to={routes.INGREDIENTS} /> : SupplierSearchIngredients}
			/>
			<PermissionRoute exact path={routes.INGREDIENTS} component={Ingredients} />
			<PermissionRoute exact path={routes.INGREDIENT_DETAIL} component={IngredientDetail} />
		</Switch>
	);
};

const mapStateToProps = (state: IApplicationState) => ({
	profile: state.user.profile
});

export default connect(mapStateToProps)(IngredientRouter);
